import type {ReactElement} from 'react';

export enum StoryPreviewPlatform {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
}

export interface StoryPreviewPlatformParts {
  avatarClassName: string;
  footerActions: ReactElement;
  headerActions: ReactElement | null;
}

export const FACEBOOK_STORY_FOOTER_ICON_PATHS: string[] = ['images/socialmedia/comment-icon-facebook-story.svg'];
export const FACEBOOK_STORY_ADD_ICON_PATH = 'images/socialmedia/add-icon-facebook-story.svg';

export const INSTAGRAM_STORY_FOOTER_ICON_PATHS: string[] = ['images/socialmedia/heart-icon-instagram-story.svg', 'images/socialmedia/share-icon-instagram-story.svg'];
